import { get, post } from './fetcher';

const SUPPORT_ENDPOINTS = {
  NOTICE_LIST: '/api/notice',
  NOTICE_DETAIL: (id) => `/api/notice/${id}`,
  CS_LIST: '/api/customer-service',
  CS_DETAIL: (id) => `/api/customer-service/${id}`,
  CS_INQUIRY: '/api/customer-service/inquiry',
  MY_INQUIRY_LIST: '/api/customer-service/inquiries',
  MY_INQUIRY_DETAIL: (id) => `/api/customer-service/inquiries/${id}`,
  ADMIN_NOTICE_LIST: '/api/admin/support/notices',
  ADMIN_INQUIRY_LIST: '/api/admin/support/inquiries',
  ADMIN_INQUIRY_REPLY: (id) => `/api/admin/support/inquiries/${id}/reply`,
};

export const getNoticeList = async () => {
  return get(SUPPORT_ENDPOINTS.NOTICE_LIST);
};

export const getNoticeDetail = async (id) => {
  return get(SUPPORT_ENDPOINTS.NOTICE_DETAIL(id));
};

export const getCustomerServiceList = async () => {
  return get(SUPPORT_ENDPOINTS.CS_LIST);
};

export const getCustomerServiceDetail = async (id) => {
  return get(SUPPORT_ENDPOINTS.CS_DETAIL(id));
};

export const createCustomerInquiry = async (payload) => {
  return post(SUPPORT_ENDPOINTS.CS_INQUIRY, payload);
};

export const getMyInquiryList = async (requester) => {
  return get(SUPPORT_ENDPOINTS.MY_INQUIRY_LIST, { requester });
};

export const getMyInquiryDetail = async (id, requester) => {
  return get(SUPPORT_ENDPOINTS.MY_INQUIRY_DETAIL(id), { requester });
};

export const getAdminNoticeList = async (token = null) => {
  return get(SUPPORT_ENDPOINTS.ADMIN_NOTICE_LIST, {}, token);
};

export const getAdminInquiryList = async (token = null) => {
  return get(SUPPORT_ENDPOINTS.ADMIN_INQUIRY_LIST, {}, token);
};

export const replyAdminInquiry = async (token, id, answerContent) => {
  return post(SUPPORT_ENDPOINTS.ADMIN_INQUIRY_REPLY(id), { answerContent }, token);
};
